import React from 'react';
import { Modal, Paper } from '@mui/material';
import EditReadinessRequirementLayout from '../layouts/EditReadinessRequirementLayout';
import {AssetReadinessRequirement} from "../../../classes/AssetReadinessRequirement";
import {Asset} from "../../../classes/Asset";

function NewReadinessRequirementModal(props: {
    assetData: Asset,
    isOpen: boolean,
    onClose: Function,
    onSubmit: Function
}) {

    const newRequirement = new AssetReadinessRequirement()
    newRequirement.assetId = props.assetData.id!

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <EditReadinessRequirementLayout
                    title="New Readiness Requirement"
                    initData={newRequirement}
                    onCancel={props.onClose}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default NewReadinessRequirementModal;